import React, { Component } from 'react';
import logo from './logo.svg';
import './App.css';
import './main.css';
import {
    BrowserRouter as Router,
    Route,
    Link,
    Redirect,
    Switch
} from "react-router-dom";
import Register from './Register'
import Upcoming from './Upcoming'
import FieldText from '@atlaskit/field-text'
import Select from '@atlaskit/select'
import Form from '@atlaskit/form';
import {auth,database} from './firebaseconfig'
import AsyncButton from './components/AsyncButton'
import StudentApp from './StudentApp/main'


class App extends React.Component {

    state = {
        authed: undefined,
        userInfo: {},
        display: undefined
    }

    componentDidMount () {
        auth.onAuthStateChanged((user) => {
            if (user) {
                this.setState({
                    authed: true,
                    userInfo: user
                })
            } else {
                this.setState({
                    authed: false,
                })
            }
        })
    }

    render() {
        console.log(this.state)
        const {authed, userInfo} = this.state
        return (
            <div>
            {this.state.authed === undefined
                ?
                undefined
                :
                <Router>
                        <div>
                            <Route path="/register" component={Register}/>
                            <Route path="/login" component={Login}/>
                            <Route path="/students"
                                   render={(props) => authed ? <StudentApp userInfo={userInfo} {...props}/> :
                                       <Redirect to={{pathname: "/login"}}/>}/>
                        </div>
                </Router>
            }
            </div>
        )
    }
}


class Login extends React.Component {

    constructor(props) {
        super(props)
        this.state = {
            email: "",
            password: "",
            data: {
                loading: false
            }
        }
        this.onChange = this.onChange.bind(this)
        this.onSubmit = this.onSubmit.bind(this)
    }

    onChange(e) {
        this.setState({[e.target.name]: e.target.value});
    };




    onSubmit() {
        this.setState({data: {loading: true}})
        auth.signInWithEmailAndPassword(this.state.email, this.state.password)
            .then(() => {
                this.props.history.push('/students')
            })
            .catch(err => {
                console.log(err)
                this.setState({data: {loading: false}})
            })
    }

    render() {
        console.log(this.state)
        const {name, email, college, password} = this.state

        const schOptions = [
            {label: "School of Chemical and Biomedical Engineering"},
            {label: "School of Civil and Environmental Engineering"},
            {label: "School of Computer Science and Engineering"},
            {label: "School of Electrical and Electronic Engineering"},
            {label: "School of Materials Science and Engineering"},
            {label: "School of Mechanical and Aerospace Engineering"},
            {label: "School of Art Design and Media"},
            {label: "School of Humanities"},
            {label: "School of Social Sciences"},
            {label: "Wee Kim Wee School of Communication and Information"},
            {label: "School of Biological Sciences"},
            {label: "School of Physical and Mathematical Sciences"},
            {label: "The Asian School of the Environment"},
            {label: "Nanyang Business School"},
            {label: "Others"}
        ].map((each,index) => {
            return (
                {label: each.label, value: index}
            )
        })
        console.log(this.state)
        return (
            <div className="registerlogin-bg">
                <img width="100" src="/img/whiteicon.svg"/>
                <h1 style={{color: "white", marginTop: "30px",}} className="text-center">Login</h1>
                <div className="login-form-container">
                    <Form
                        name="layout-example"
                        onSubmit={this.onSubmit}
                    >
                        <FieldText
                            onChange={this.onChange}
                            name="email"
                            label="Email"
                            type="email"
                            autoComplete="on"

                            shouldFitContainer
                            value={email}
                        />
                        <FieldText
                            onChange={this.onChange}
                            name="password"
                            label="Password"
                            type="password"
                            autoComplete="on"

                            shouldFitContainer
                            value={password}
                        />
                        <div style={{marginTop: '20px'}}>
                            <AsyncButton type="submit" isFullWidth buttonText="Login" loading={this.state.data.loading}/>
                        </div>
                    </Form>
                </div>
            </div>
        )
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js